import { useInfiniteQuery, useQuery } from "react-query";
import { supabase } from "../../config/supabaseClient";

/**
 * Load content
 */
export function useLoadSocialLinks(user_id: string) {
  async function getSocialLinks({ pageParam = 1 }) {
    const { data, error }: any = await supabase
      .from("user")
      .select("*")
      .eq("user_id", user_id);
      // .limit(1);

    if (error) {
      throw new Error(error.message);
    }

    const row = Array.isArray(data) ? data[0] : undefined;

    // If no user row yet, return a safe empty structure
    if (!row) {
      return { active: {}, data: null, order: [] as string[] };
    }

    const order =
      typeof row.social_links_order === "string"
        ? row.social_links_order
            .split(",")
            .map((v: string) => v.trim())
            .filter(Boolean)
        : ([] as string[]);

    const entries = Object.entries(row).filter(
      ([key, value]) =>
        key.startsWith("social_") &&
        key !== "social_links_order" &&
        value !== null &&
        value !== ""
    );

    const sortedEntries =
      order.length === 0
        ? entries
        : entries.sort(([keyA], [keyB]) => {
            const aIdx = order.indexOf(keyA.replace("social_", ""));
            const bIdx = order.indexOf(keyB.replace("social_", ""));
            const aOrder = aIdx === -1 ? Number.MAX_SAFE_INTEGER : aIdx;
            const bOrder = bIdx === -1 ? Number.MAX_SAFE_INTEGER : bIdx;
            return aOrder - bOrder;
          });

    const transformedObject = sortedEntries.reduce((acc: any, [key, value]) => {
      acc[key.replace("social_", "")] = value;
      return acc;
    }, {});

    return { active: transformedObject, data: row, order };
  }

  return useQuery(["getSocialLinks", user_id], getSocialLinks, {
    enabled: Boolean(user_id),
  });
}
